import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import CloseIcon from "../assets/img/close-icon.svg";
import { handleimageUrl } from "../utils/ApiFunctions";

function PdfViewPopup(props) {
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        className="modasss"
      >
        <Modal.Body>
          <div className="edit-profile">
            <button onClick={() => props.onHide()} className="btn-btn-close">
              <img src={CloseIcon} alt="" />
            </button>
            <div className="image-view">
              {(props.image && props.image?.split(".")[1] == "jpg") ||
              (props.image && props.image?.split(".")[1] == "png") ||
              (props.image && props.image?.split(".")[1] == "svg") ||
              (props.image && props.image?.split(".")[1] == "jpeg") ? (
                <img src={props.image && handleimageUrl(props?.image)} />
              ) : (
                <iframe
                  src={props.image && handleimageUrl(props.image)}
                  width="100%"
                  height="100%"
                  title="PDF Viewer"
                />
              )}

              {/* <img src={handleimageUrl(props.image)} /> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default PdfViewPopup;
